import Vue from 'vue';

const GAME_INFO = (state, newState) => {
	newState = {...state, ...newState};
	Vue.set(state, 'games', newState.games);
	Vue.set(state, 'props', newState.props);
	Vue.set(state, 'channels', newState.channels);
	Vue.set(state, 'channelToday', newState.channelToday);
	Vue.set(state, 'xienChannels', newState.xienChannels);
};

export default {
    GAME_INFO
};